import React from 'react';
import styled, { keyframes } from 'styled-components';
import { CSSTransitionGroup } from 'react-transition-group';
import Button from '../base/Button';
const IconSuccess = require('react-icons/lib/md/check');
const IconFail = require('react-icons/lib/md/warning');
const IconInfo = require('react-icons/lib/md/info-outline');

/*
    PROPS
    title:      <string>
    body:       <string> || [<string>, ...],
    type:       <string> expected 'success', 'fail', 'info' defaults to 'info'
    button_action: (),
    button_label: <string>
*/

export default class Alert extends React.Component {

    constructor(props) {
        super(props);

        const fadeIn = keyframes`
            from {
              opacity: 0;
              transform: translate3d(0, 10%, 0);
            }
            to {
              opacity: 1;
              transform: none;
            }
        `;

        this.Container = styled.div `

            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(26, 29, 36, 0.3);
            z-index: 10;
            text-align: center;

            &.w_title{
                .modal .modal_body{
                    padding: 16px 16px 32px;
                }
            }
            &.w_body{
                .modal .modal_title{
                    padding: 32px 16px 0px;
                }
            }

            .modal-appear{
                animation: ${fadeIn} 0.5s 0s both;
            }
            .modal{
                margin: 5% 30%;
                background-color: #fff;
                border-radius: 2px;
                text-align: center;
                box-shadow: 0 4px 12px rgba(0,0,0,0.12);
                .modal_head{
                    background-color: ${this.getHeadColor()};
                    color: #fff;
                    padding: 40px;
                    border-top-left-radius: 2px;
                    border-top-right-radius: 2px;
                    svg{
                        width: 100px;
                        height: 100px;
                    }
                }
                .modal_title{
                    padding: 32px 16px 32px;
                    font-size: 24px;
                }
                .modal_body{
                    padding: 32px 16px;
                    font-size: 16px;
                    opacity: 0.8;
                }
                .modal_footer{
                    background-color: ${props => props.theme.colors.gray_3};
                    padding: 10px 20px;
                    border-top: 1px solid ${props => props.theme.colors.gray_2};
                    border-bottom-left-radius: 2px;
                    border-bottom-right-radius: 2px;
                    button{
                        background-color: ${this.getHeadColor()};
                        border-color: ${this.getDarkHeadColor()};
                        display: inline-block;
                        width: 150px;
                        &:HOVER{
                            background-color: ${this.getDarkHeadColor()};
                        }
                        &:last-child{
                            margin-left: 12px;
                        }
                    }
                }
            }

        `;
    }

    getHeadColor() {
        switch (this.props.params.type) {
            case 'success':
            return `#00C896`;
            case 'fail':
            return `#cc4d4d`;
            default:
            return `#3378d4`;
        }
    }

    getDarkHeadColor() {
        switch (this.props.params.type) {
            case 'success':
            return `#00a87e`;
            case 'fail':
            return `#ab2f2f`;
            default:
            return `#2063bb`;
        }
    }

    getIcon() {
        switch (this.props.params.type) {
            case 'success': {
                return <IconSuccess />;
            }
            case 'fail': {
                return <IconFail />;
            }
            default: {
                return <IconInfo />;
            }
        }
    }

    renderBody() {
        if (this.props.params.body && typeof this.props.params.body !== "string") {
            return (
                this.props.params.body.map((sentence, i) => {
                    return (<p key={i}>
                        {sentence}
                    </p>);
                })
            );
        }
        return (<p>{this.props.params.body}</p>);
    }

    render() {
        return (
            <this.Container className={`${this.props.params.title ? 'w_title' : null} ${this.props.params.body ? 'w_body' : null}`}>
                <CSSTransitionGroup
                    transitionName={`modal`}
                    transitionAppear={true}
                    transitionLeave={false}
                    transitionEnter={false}
                    transitionAppearTimeout={ 1000 } >
                    <div className="modal">
                        <div className="modal_head">
                            {this.getIcon()}
                        </div>
                        {
                            this.props.params.title ?
                            <div className="modal_title">
                                {this.props.params.title}
                            </div>
                            :
                            null
                        }
                        {
                            this.props.params.body ?
                            <div className="modal_body">
                                {this.renderBody()}
                            </div>
                            :
                            null
                        }
                        <div className="modal_footer">
                            <Button label={this.props.params.button_label || 'OK'} onClick={this.props.params.button_action}/>
                        </div>
                    </div>
                </CSSTransitionGroup>
            </this.Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/base/Alert.js